import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { useCaseStatusLanguage } from '../../../../routes/CaseStatus/CaseStatusLanguageProvider';

type Props = { onLoginClick: () => void };

const LoginPromptCard = ({ onLoginClick }: Props) => {
  const theme = useTheme();
  const { t } = useCaseStatusLanguage();

  return (
    <Paper elevation={1}>
      <Box>
        <Typography sx={{ mb: 0.25 }} color="text.secondary">
          {t('WantFullAccessToCases')}
        </Typography>
        <Typography
          component="span"
          onClick={onLoginClick}
          sx={{
            color: theme.palette.secondary.main,
            fontWeight: 700,
            cursor: 'pointer',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          {t('LogInWithBankID')} →
        </Typography>
      </Box>
    </Paper>
  );
};

export default LoginPromptCard;

